import 'css-chunksrc/client/scenes/assignToTask/tasksSelection/input/styles.scss';export default {
  "input": "_input_1huec_1",
  "opened": "_opened_1huec_12",
  "placeholder": "_placeholder_1huec_16",
  "selected": "_selected_1huec_22",
  "name": "_name_1huec_27",
  "toggleIcon": "_toggleIcon_1huec_32"
};